<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-add-bold`]" width="1em" height="1em" v-bind="$attrs"><path d="M6 0C6.62132 0 7.125 0.50368 7.125 1.125V4.875H10.875C11.4963 4.875 12 5.37868 12 6C12 6.62132 11.4963 7.125 10.875 7.125H7.125V10.875C7.125 11.4963 6.62132 12 6 12C5.37868 12 4.875 11.4963 4.875 10.875V7.125H1.125C0.50368 7.125 0 6.62132 0 6C0 5.37868 0.50368 4.875 1.125 4.875H4.875V1.125C4.875 0.50368 5.37868 0 6 0Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAddBold',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
